<template>
<div>
    <ShowAllOrders orderStatus="submitted"></ShowAllOrders>
</div>
</template>

<script>
import ShowAllOrders from '@/components/App/dashboard/ShowAllOrders.vue';
export default {
    name: "ActiveTab",
    components: {
        ShowAllOrders
    }
}
</script>

<style>
</style>